/*
  Widerrufsformular, sections/beneos-withdraw.liquid.

  Sendet die Erklaerung an die Cloud und zeigt danach Kennung und
  Eingangszeitpunkt an. Der Absprung bleibt bewusst auf derselben Seite: der
  Kunde soll den Nachweis sofort sehen und nicht erst in seinem Postfach suchen.

  Als einfache Formularanfrage, nicht als JSON. Damit entfaellt der Vorabflug
  ueber OPTIONS, und der Aufruf haengt nicht an einer zweiten Antwort des
  Servers. Alle Texte kommen aus data-Attributen, weil sie im Liquid nach
  Sprache verzweigen und ein Rechtssatz nicht in ein Skript gehoert.
*/
(function () {
  var form = document.querySelector('#beneos-withdraw .wd-form');
  if (!form) return;

  var done   = document.querySelector('[data-wd-done]');
  var msgBox = form.querySelector('[data-wd-msg]');
  var btn    = form.querySelector('[data-wd-submit]');
  var btnText = btn ? btn.textContent : '';

  function zeigeMeldung(text) {
    if (!msgBox) return;
    msgBox.textContent = text;
    msgBox.hidden = false;
    msgBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Der Zeitpunkt kommt vom Server und wird nur zur Anzeige umgeformt. Ein im
     Browser gebildeter Zeitstempel waere die Uhr des Kunden und damit als
     Nachweis wertlos. */
  function zeit(iso) {
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString(document.documentElement.lang || 'en', {
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
      });
    } catch (e) { return iso; }
  }

  var fehlerText = {
    missing_fields: form.getAttribute('data-msg-fields'),
    invalid_email:  form.getAttribute('data-msg-mail'),
    rate_limited:   form.getAttribute('data-msg-rate')
  };

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (msgBox) msgBox.hidden = true;

    var name = form.elements.name.value.trim();
    var mail = form.elements.email.value.trim();
    var vertrag = form.elements.contract.value.trim();
    if (!name || !vertrag) { zeigeMeldung(form.getAttribute('data-msg-fields')); return; }
    if (mail.indexOf('@') < 1 || mail.indexOf('.', mail.indexOf('@')) < 0) {
      zeigeMeldung(form.getAttribute('data-msg-mail')); return;
    }

    var daten = new URLSearchParams();
    ['name', 'email', 'contract', 'address', 'ordered_on', 'received_on', 'note', 'website'].forEach(function (k) {
      if (form.elements[k]) daten.append(k, form.elements[k].value);
    });
    daten.append('locale', form.getAttribute('data-locale') || 'en');

    if (btn) { btn.disabled = true; btn.textContent = form.getAttribute('data-msg-sending') + '...'; }

    fetch(form.getAttribute('data-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: daten.toString()
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || res.j.result !== 'ok') {
          var key = res.j && res.j.information;
          zeigeMeldung(fehlerText[key] || form.getAttribute('data-msg-error'));
          if (btn) { btn.disabled = false; btn.textContent = btnText; }
          return;
        }
        if (!done) { location.reload(); return; }
        done.innerHTML =
          '<h2>' + esc(done.getAttribute('data-title')) + '</h2>' +
          '<dl>' +
            '<dt>' + esc(done.getAttribute('data-label-ref')) + '</dt><dd>' + esc(res.j.reference) + '</dd>' +
            '<dt>' + esc(done.getAttribute('data-label-time')) + '</dt><dd>' + esc(zeit(res.j.declared_at)) + '</dd>' +
          '</dl>' +
          '<p>' + esc(done.getAttribute(res.j.confirmed ? 'data-mail' : 'data-nomail')) + '</p>';
        done.hidden = false;
        form.hidden = true;
        done.scrollIntoView({ block: 'center', behavior: 'smooth' });
      })
      .catch(function () {
        zeigeMeldung(form.getAttribute('data-msg-error'));
        if (btn) { btn.disabled = false; btn.textContent = btnText; }
      });
  });
})();
